export default __webpack_public_path__ + "static/media/cp_geo_ma.fa3e9960.svg";